import { Component, Inject } from '@angular/core';
import { ISitemap, SITEMAP } from 'pbc.angular';
import { IFilterConfig, ISelection } from 'pbc.types';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { IVorlageResponse, VorlageQueryFilterConfig } from 'fa-kt.types';
import { VorlageService } from '../service';

@Component({
  selector: 'fa-kt-vorlage-filter',
  templateUrl: './vorlage-filter.component.html',
  styleUrls: ['./vorlage-filter.component.css'],
})
export class VorlageFilterComponent {
  readonly subscriptions: Subscription[] = [];

  public VorlageFilterConfig: IFilterConfig<IVorlageResponse>;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public vorlage: VorlageService,
  ) {
    this.VorlageFilterConfig = VorlageQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.VorlageFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.VorlageFilterConfig[index].selections = shapes;
  }
}
